export default "__VITE_ASSET__Cczsq4s9__"